const cardProduct = document.querySelectorAll(".product-article"),
  cardProductTwo = document.querySelectorAll(".product-article-second");
if (cardProduct.length > 0) {
  cardProduct.forEach((product) => {
    const openVariants = product.querySelector(
        ".product-article__handlers--open-variants"
      ),
      contentVariants = product.querySelector(".product-article__variants"),
      closeVariants = product.querySelector(
        ".product-article__variants--close"
      ),
      productOptions = product.querySelectorAll(
        ".product-article__variants--ul"
      ),
      addToCart = product.querySelector(
        ".product-article__variants--add-to-cart"
      );

    let variantOptions = {},
      dataProduct = null;

    if (closeVariants && contentVariants) {
      closeVariants.addEventListener("click", () => {
        contentVariants.classList.remove("open");
      });
    }

    if (openVariants && contentVariants) {
      const productHandle = contentVariants.getAttribute("handle-product");

      openVariants.addEventListener("click", async () => {
        contentVariants.classList.add("open");

        dataProduct = await fetchProductData(productHandle);
        if (!dataProduct) {
          console.error("No se pudieron cargar los datos del producto.");
        }
      });
    }

    productOptions.forEach((option) => {
      option.addEventListener("change", () => {
        const typeOption = option.getAttribute("option-name");
        variantOptions[typeOption] = option.value;

        if (dataProduct && dataProduct.variants) {
          const filteredVariant = dataProduct.variants.find((variant) => {
            return Object.keys(variantOptions).every((key) => {
              const optionIndex = Object.keys(variantOptions).indexOf(key) + 1;
              return variant[`option${optionIndex}`] === variantOptions[key];
            });
          });
          addToCart.setAttribute("data-product-id", filteredVariant.id);
          console.log("Variante filtrada:", filteredVariant || "No encontrada");
        } else {
          console.warn("Datos del producto no cargados aún.");
        }
        addToCart.classList.add("visible");
      });
    });
  });

  async function fetchProductData(productHandle) {
    try {
      const response = await fetch(`/products/${productHandle}.js`);

      if (!response.ok) {
        throw new Error("Error al obtener el producto");
      }
      const productData = await response.json();
      return productData;
    } catch (error) {
      console.error("Error:", error);
      return null;
    }
  }
}
if (cardProductTwo.length > 0) {
  cardProductTwo.forEach((product) => {
    const contentVariants = product.querySelector(
        ".product-article-second__variants"
      ),
      productOptions = product.querySelectorAll(
        ".product-article-second__variants--ul"
      ),
      addToCart = product.querySelector(
        ".product-article-second__variants--add-to-cart"
      );

    if (contentVariants) {
      let variantOptions = {},
        productHandle = contentVariants?.getAttribute("handle-product"),
        dataProduct = null;
      productOptions.forEach((option) => {
        option.addEventListener("change", async () => {
          console.log(option);
          dataProduct = await fetchProductData(productHandle);
          console.log(dataProduct);
          const typeOption = option.getAttribute("option-name");
          variantOptions[typeOption] = option.value;

          if (dataProduct && dataProduct.variants) {
            const filteredVariant = dataProduct.variants.find((variant) => {
              return Object.keys(variantOptions).every((key) => {
                const optionIndex =
                  Object.keys(variantOptions).indexOf(key) + 1;
                return variant[`option${optionIndex}`] === variantOptions[key];
              });
            });
            addToCart.setAttribute("data-product-id", filteredVariant.id);
          } else {
            console.warn("Datos del producto no cargados aún.");
          }
          addToCart.classList.add("visible");
        });
      });
    }
  });

  async function fetchProductData(productHandle) {
    try {
      const response = await fetch(`/products/${productHandle}.js`);

      if (!response.ok) {
        throw new Error("Error al obtener el producto");
      }
      const productData = await response.json();
      return productData;
    } catch (error) {
      console.error("Error:", error);
      return null;
    }
  }
}
